module.exports = __webpack_public_path__ + "img/after3.94f3e479.png";